<template>
  <section class="sectionOuterBox" aria-label="Planbook Mobile anywhere access">
    <div class="sectionInnerBox text-left py-12">
      <v-container class="container">
        <v-row>
          <v-col cols="12" md="6" class="hidden-xs hidden-sm hidden-xxs">
            <div class="sectionImageContainer">
              <div class="mobileImage">
                <img src="https://cdn.planbook.com/images/welcome-mobile-ballon.png" alt="">
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="my-auto">
            <h2 class="sectionListHeader md cBlue">{{ $t('mobile.anywhere.title') }}</h2>
            <div>
              <div class="mobileContent" style="margin-top: 25px; text-align: left;">
                {{ $t('mobile.anywhere.description') }}
                <span style="font-weight: bold;">{{ $t('mobile.anywhere.highlight') }}</span>
                {{ $t('mobile.anywhere.description2') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Anywhere extends Vue {
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1199px) {
  .mobileImage {
    margin: 0 auto;
  }

  .mobileImage img {
    width: 100%;
    object-fit: contain;
  }
}

.sectionListHeader {
  font-size: 32px;
  font-weight: 600;
}

.sectionListHeader.md {
  font-size: 28px;
}

.mobileContent {
  text-align: justify;
  line-height: 28px;
  padding-right: 55px;
}

.mobileContent p {
  margin-bottom: 20px;
}
</style>
